import { CultureInfo } from '../culture-info.model';
import { CultureInfoFfLatn } from './ff-Latn';

/**
 * @ignore
 */
export const CultureInfoFfLatnBF: CultureInfo = {
  name: 'ff-Latn-BF',
  displayName: 'Pulaar (Latn, Burkibaa Faaso)',
  iso3LanguageCode: 'ful',
  iso2LanguageCode: 'ff',
  ietfLanguageTag: 'ff-Latn-BF',
  parent: CultureInfoFfLatn
};
